import {FocusEvent} from 'react'

export const setAutocompleteNone = (event: FocusEvent<HTMLElement>) =>
  (event.target as HTMLInputElement).setAttribute('autocomplete', 'off')
